import React, { createContext, useState, useEffect } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSessionExpiredCallback } from "../api";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
    const [sessionModalOpen, setSessionModalOpen] = useState(false);
    const navigate = useNavigate();

    const triggerSessionExpired = () => {
        setSessionModalOpen(true);
    };

    const handleSessionModalClose = () => {
        setSessionModalOpen(false);
        navigate("/login");
    };

    useEffect(() => {
        setSessionExpiredCallback(triggerSessionExpired); // Set the callback
        return () => {
            setSessionExpiredCallback(null);
        };
    }, []);

    return (
        <SessionContext.Provider value={{ triggerSessionExpired }}>
            {children}
            <Modal
                open={sessionModalOpen}
                onClose={handleSessionModalClose}
                aria-labelledby="session-expired-modal-title"
                aria-describedby="session-expired-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: 400,
                        bgcolor: "background.paper",
                        borderRadius: 3,
                        boxShadow: 24,
                        p: 4,
                        textAlign: "center",
                    }}
                >
                    <Typography
                        id="session-expired-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2, color: "red", fontWeight: "bold" }}
                    >
                        Session Expired
                    </Typography>
                    <Typography id="session-expired-modal-description" sx={{ mb: 4 }}>
                        Your session has expired. Please log in again to continue.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSessionModalClose}
                        sx={{ bgcolor: "darkblue" }}
                    >
                        Go to Login
                    </Button>
                </Box>
            </Modal>
        </SessionContext.Provider>
    );
};
